// extracted by mini-css-extract-plugin
export default {"footer":"DmBNPW0TBwhFBUOxg7FH","partialLogo":"z7INppXVJSvgxhn83S_p","text":"snoDN_0U0AnI5vkzrxWo","versionWrapper":"qi3FvPgnHV8sNpRG7fEM","portalName":"w2SGPBiFm3s3at_EYo_n"};